var _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 15,
    x2: 3,
    y1: 9,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 14,
    x2: 4,
    y1: 14,
    y2: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 12,
    x2: 6,
    y1: 4,
    y2: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align-center.16e62705d870c5badef8394ca86eaf02.svg";
export { ForwardRef as ReactComponent };